import { useGameBySlug } from '@/api/games';
import { useRouter } from 'next/router';

export function useGamesBySlugWithQueryParams() {
  //@ts-ignore
  const { query, asPath, pathname } = useRouter();
  const gameSlug: string | undefined = query.gameSlug as string;

  function getSlug() {
    if (asPath.includes('originals')) {
      return pathname?.split('/')?.[pathname?.split('/')?.length - 1] as string;
    }
    return gameSlug as string;
  }

  return useGameBySlug({
    slug: getSlug(),
  });
}
